import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import clientsubscriptionApiController from "services/clientsubscription.service";
import HandleError from "../HandleError";
import HandleResponse from "../HandleResponse";

export const ClientSubscriptionListViewApi = createAsyncThunk("clientsubscription/listview", async (formValues, thunkAPI) => {
  try {
    const resposedata = await clientsubscriptionApiController
      .view(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "listview"))
      .catch((error) => HandleError(thunkAPI, error, "listview"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const SubscriptionCancellationApi = createAsyncThunk("subscription/cancel", async (formvalues, thunkAPI) => {
  try {
    const resposedata = await clientsubscriptionApiController
      .cancelsubscription(formvalues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "cancelsubscription"))
      .catch((error) => HandleError(thunkAPI, error, "cancelsubscription"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue({ status: error.response.status, message: message });
  }
});

const initialState = {
  isListView: [],
  isSubScriptionCancel: "",
  isApiStatus: {
    ClientSubscriptionListViewApi: "",
    SubscriptionCancellationApi: "",
  },
};

const clientsubscriptionSlice = createSlice({
  name: "clientsubscription",
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(ClientSubscriptionListViewApi.pending, (state) => {
        state.isApiStatus = { ...state.isApiStatus, ClientSubscriptionListViewApi: "loading" };
      })
      .addCase(ClientSubscriptionListViewApi.fulfilled, (state, action) => {
        let old_current_page = state.isListView.current_page ? state.isListView.current_page : "";
        let new_current_page = action.payload.current_page ? action.payload.current_page : "";
        let viewdata = state.isListView && state.isListView.data;
        let newviewdata = action.payload && action.payload.data;
        state.isListView = action.payload;
        if (old_current_page && new_current_page && old_current_page < new_current_page && old_current_page != new_current_page) {
          viewdata && newviewdata ? (state.isListView.data = [...viewdata, ...newviewdata]) : action.payload;
        }
        state.isApiStatus = { ...state.isApiStatus, ClientSubscriptionListViewApi: "succeeded" };
        state.isListView = action.payload;
      })
      .addCase(ClientSubscriptionListViewApi.rejected, (state) => {
        state.isApiStatus = { ...state.isApiStatus, ClientSubscriptionListViewApi: "failed" };
        state.isListView = [];
      })
      .addCase(SubscriptionCancellationApi.pending, (state) => {
        state.isApiStatus = { ...state.isApiStatus, SubscriptionCancellationApi: "loading" };
      })
      .addCase(SubscriptionCancellationApi.fulfilled, (state, action) => {
        state.isApiStatus = { ...state.isApiStatus, SubscriptionCancellationApi: "succeeded" };
        state.isSubScriptionCancel = action.payload;
      })
      .addCase(SubscriptionCancellationApi.rejected, (state) => {
        state.isApiStatus = { ...state.isApiStatus, SubscriptionCancellationApi: "failed" };
      });
  },
});
// Action creators are generated for each case reducer function
export const { reset } = clientsubscriptionSlice.actions;
export default clientsubscriptionSlice.reducer;
